import { Injectable } from '@angular/core';
import { BaseHttpService, HttpResult } from '../../core/services/base-http.service';
import { ActivityRequestModel, ActivityResponseModel, AdsActivityRequestModel, CatalogueAdsResponseModel, ParamsToGetAdsList, PavilionListResponseModel, ProductDetailsResponseModel, ProductListResponseModel } from './digital-catalogue.model';
import { CompanyDetailsModel, CompanyListModel, ParamsToGetCompanyList, ParamsToGetProductsList, PavilionGroupModel } from './digital-catalogue.model';
import { Observable } from 'rxjs';
import { BaseResponse } from '../../shared/models/base-response.model';
import { apiEndpoints } from '../../core/constants/api-strings';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigitalCatalogueApiService extends BaseHttpService {

  constructor() {
    super();
  }

  // Base URL for farmer-related APIs
  private readonly farmerBaseUrl = environment.farmer_base_url;

  // Base URL for master-related APIs
  private readonly masterBaseUrl = environment.master_base_url;

  // Logged-in farmer's ID
  private farmerId = this.storage.getLoggedUserId();

  // Event code, defaults to 'KISAN25' if not set
  private eventcode = this.storage.getEventCode() || "KISAN25";

  /**
   * Fetch the list of pavilions
   * @returns
   */
  getPavilionListApi(): Observable<HttpResult<BaseResponse<PavilionListResponseModel>>> {
    let serviceName = `${this.masterBaseUrl +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.pavilions
      }`;

    return this.get<BaseResponse<PavilionListResponseModel>>(serviceName, {}, false);
  }

  /**
   * Fetch the list of companies
   * @returns
   */

  getCompaniesList(params?: ParamsToGetCompanyList, fromWishlist?: boolean): Observable<HttpResult<BaseResponse<CompanyListModel>>> {
    // Set useAuth to false for master API calls
    const useAuth = fromWishlist ? true : false;

    const base = fromWishlist
    ? `${this.farmerBaseUrl}${this.farmerId}${apiEndpoints.farmerRegister.events}`
    : `${this.masterBaseUrl}${apiEndpoints.farmerDigitalCatalog.events}`;

    const serviceName = `${base +
    this.eventcode +
    apiEndpoints.farmerDigitalCatalog.companies
    }`;

    return this.get<BaseResponse<CompanyListModel>>(serviceName, params, useAuth);
  }


  /**
   * Fetch the list of products
   * @returns
   */
  getProductListApi(params?: ParamsToGetProductsList, fromWishlist?: boolean): Observable<HttpResult<BaseResponse<ProductListResponseModel>>> {
    // Set useAuth to false for master API calls
    const useAuth = fromWishlist ? true : false;

    const base = fromWishlist
    ? `${this.farmerBaseUrl}${this.farmerId}/`
    : this.masterBaseUrl;

    const serviceName = `${base +
    apiEndpoints.farmerDigitalCatalog.events +
    this.eventcode +
    apiEndpoints.farmerDigitalCatalog.products
    }`;

    return this.get<BaseResponse<ProductListResponseModel>>(serviceName, params, useAuth);
  }

  getCompanyDetails(encodedCompanyId: string): Observable<HttpResult<BaseResponse<CompanyDetailsModel>>> {
    let serviceName = `${this.farmerBaseUrl +
      this.farmerId +
      apiEndpoints.farmerRegister.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.companies +
      '/' + encodedCompanyId
      }`;

    return this.get<BaseResponse<CompanyDetailsModel>>(serviceName, {}, true);
  }

  /**
   * get product details
   * @param productId 
   * @returns 
   */
  getProductDetails(productId: number | string): Observable<HttpResult<BaseResponse<ProductDetailsResponseModel>>> {
    let serviceName = `${this.farmerBaseUrl +
      this.farmerId + '/' +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.products + '/' + productId
      }`;

    return this.get<BaseResponse<ProductDetailsResponseModel>>(serviceName, {}, true);
  }

  /**
   * post api to save user activity
   */

  saveUserActivityApi(
    payload: ActivityRequestModel
  ): Observable<HttpResult<BaseResponse<ActivityResponseModel>>> {

    let serviceName = `${this.farmerBaseUrl +
      this.farmerId + '/' +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.activity
      }`;

    return this.post<BaseResponse<ActivityResponseModel>>(
      serviceName,
      payload,
      {},
      true
    );

  }

  /**
   * Get the list of catalogue ads.
   * @returns Observable of HttpResult containing BaseResponse with an array of CatalogueAdsResponseModel
   */
  getAds(params?: ParamsToGetAdsList): Observable<HttpResult<BaseResponse<CatalogueAdsResponseModel[]>>> {
    let serviceName = `${this.masterBaseUrl +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.ads
      }`;

    return this.get<BaseResponse<CatalogueAdsResponseModel[]>>(serviceName, params, false);
  }

  /**
   * @description Save Ads activity
   */
  saveAdsActivityApi(payload: AdsActivityRequestModel): Observable<HttpResult<BaseResponse<ActivityResponseModel>>> {
    let serviceName = `${this.farmerBaseUrl +
      this.farmerId + '/' +
      apiEndpoints.farmerDigitalCatalog.events +
      this.eventcode +
      apiEndpoints.farmerDigitalCatalog.adsactivity
      }`;

    return this.post<BaseResponse<ActivityResponseModel>>(serviceName, payload, {}, true);
  }


}

